import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'
const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/setting',
        name: 'setting',
		subheader: languages.setting.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "05",
            icon: "setting",
        },
        component: PageAll,
		children: [
			{
				path: '/setting',
				name: 'setting',
				component: resolve => require(['@/pages/setting/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.setting.title1,
					permCode: "0501",
				},
			}
		]
    },
]
  